import { DisplayLanguage } from './constants/stringConstants';
import { DISPLAY_LANGUAGE_LIST } from './constants/utilConstants';

const lanuageRegex = /^\/([a-zA-Z]{2})\//;

/*
 * Checks whether the url starts with two letters. Removes if present;
 * * */
export const urlLanguageValidations = (url: string) => {
  let newUrl = url;
  const localeMatch = newUrl?.match(lanuageRegex);
  if (localeMatch) {
    const alienLanguage = localeMatch[0];
    if (!DISPLAY_LANGUAGE_LIST.some((item) => item.includes(localeMatch[1]))) {
      newUrl = url.replace(alienLanguage, '/');
    }
  }
  return newUrl;
};

export const urlDisplayLanguageHandler = (
  url: string,
  routerLocale: string,
  routerPath: string,
  displayLanguageCookie: string
) => {
  let newURL = url;
  //if the expected url and the router location are not same then redirect
  if (routerPath !== newURL) {
    //check if the cookie is there othewise make page english can take the router
    if (
      displayLanguageCookie &&
      displayLanguageCookie !== DisplayLanguage.ENGLISH
    ) {
      newURL = `/${displayLanguageCookie}${newURL}`;
    } else if (
      routerLocale &&
      routerLocale !== DisplayLanguage.ENGLISH &&
      (!displayLanguageCookie ||
        displayLanguageCookie === DisplayLanguage.ENGLISH)
    ) {
      newURL = `/${routerLocale}${newURL}`;
    }
  } else if (
    displayLanguageCookie &&
    displayLanguageCookie !== DisplayLanguage.ENGLISH &&
    routerLocale !== displayLanguageCookie
  ) {
    newURL = `/${displayLanguageCookie}${newURL}`;
  }
  return newURL;
};
